import React from 'react'
import * as RT from '../../constants/Routing'
import Card from '../Community/Card'
import LoadingGif from '../../lib/images/loading.gif'
export default class Component extends React.Component {
  componentWillMount = () => {
    if (this.props.Search.searchCommunity === null) {
      const { history } = this.props
      history.push(RT.ROOT_PATH)
    }
  }

  componentWillUnmount = () => {
    this.props.searchCommunityResultRemove()
  }

  render = () => {
    const results = this.props.Search.searchCommunity
    let resultsCount = 0
    let body, noticeText
    if (results) {
      resultsCount = results.communities.length
    }

    if (resultsCount === 0) {
      noticeText = 'お探しの条件ではサークルが見つかりませんでした。'
      body = (
        <div className='col-12'>
          <a onClick={() => document.querySelector('.searchToggleBtn').click()} className='btn btn-block btn-primary'>違う条件で検索する</a>
        </div>
      )
    } else {
      noticeText = `${resultsCount}件のサークルが見つかりました`
      body = results.communities.map(circle => {
        return (
          <Card circle={circle} key={circle.id} />
        )
      })
    }

    return (
      <div className='container'>
        <h2 className='headline'>検索結果</h2>
        <p className='notice-text'>{noticeText}</p>
        <div className='row'>
          {body}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx